import React from "react";
import { FaBell } from "react-icons/fa6";

export default function NotificationIcon({ count = 5, onClick }) {
    return (
        <div
            className="botao-notificacao"
            style={{ position: "relative", display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
            onClick={onClick}
        >
            <FaBell size={28} />
            {count > 0 && (
                <span
                    style={{
                        position: "absolute",
                        top: "-6px",
                        right: "-8px",
                        background: "#E24B4A",
                        color: "#fff",
                        fontSize: "11px",
                        fontWeight: "500",
                        minWidth: "18px",
                        height: "18px",
                        borderRadius: "9px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "solid 2px #D0EAF2",
                        padding: "3px"
                    }}
                >
                    {count > 99 ? "99+" : count}
                </span>
            )}
        </div>
    );
}
